import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import NavbarMenu from "./SidebarResponsive";
import LayoutHeader from "./LayoutHeader";
import useBreadcrumbs from "use-react-router-breadcrumbs";

const routesMonitoring = [
  { path: "/", breadcrumb: null },
  { path: "/monitoring", breadcrumb: "Monitoring" },
  { path: "/monitoring/overview", breadcrumb: "Overview" },
  { path: "/monitoring/performance", breadcrumb: "Performance" },
  { path: "/monitoring/reports", breadcrumb: "Reports" },
  { path: "/monitoring/alerts", breadcrumb: "Alerts" },
  { path: "/monitoring/logs", breadcrumb: "Logs" },
];

const MonitoringLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const breadcrumbs = useBreadcrumbs(routesMonitoring);
  const filteredBreadcrumbs = breadcrumbs.filter(
    ({ match }) => match.pathname !== "/"
  );

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="hidden md:block">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      <NavbarMenu />

      <main
        className={`w-full transition-all duration-300 ${
          collapsed ? "md:ml-16" : "md:ml-64"
        } mt-16 md:mt-0`}
      >
        <LayoutHeader breadcrumbs={filteredBreadcrumbs} />
        <Outlet />
      </main>
    </div>
  );
};

export default MonitoringLayout;
